import { BasketContentCartItem } from './BasketContentCartItem';
import { BasketContentFooter } from './BasketContentFooter';

export function BasketContentCart(props) {
    const { shoppingBag, actions } = props;
    const { items } = shoppingBag;
    
    return (
        <>
            <div className="show-box flex-column active-group active" id="bag-box" style={{ display: 'flex' }}>
                {items.map((item, index) => (<BasketContentCartItem item={item} key={`${item.fabric.id}-${index}`} actions={actions} />))}
                {items.length === 0 && <div className="body-text3 mt-32">You have no items in your shopping bag.</div>}
            </div>
            {items.length > 0 && <BasketContentFooter shoppingBag={shoppingBag} />}
        </>
    );
}